import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useEffect, useRef } from 'react';
import { create } from 'zustand';
import { useFlag } from '~/components/Flag';

export const useBodyScrollLock = <T extends HTMLElement>(locked: boolean) => {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (locked) {
      disableBodyScroll(ref.current);
    } else {
      enableBodyScroll(ref.current);
    }
  }, [locked]);

  useEffect(() => () => clearAllBodyScrollLocks());

  return {
    ref,
  };
};

export const useNews = () => {
  const { hidden } = useFlag({
    name: 'LANDS',
    value: '2.0.0',
    disabled: import.meta.env.VITE_VERSION !== '2.0.0',
  });
  return !hidden;
};

export type SidebarStore = {
  active: boolean;
  setActive: (active: boolean) => void;
};

export const useSidebarStore = create<SidebarStore>((set) => ({
  active: false,
  setActive: (active) =>
    set(() => ({
      active,
    })),
}));
